import styled from "@emotion/styled";
import { fontRoboto } from "@product/scmp-sdk";

import { BaseLink } from "~/components/common/base-link";
import LogoFlag from "~/components/header/icon-logo-flag.svg";
import LogoText from "~/components/header/icon-logo-text.svg";
import { ZIndexLayer } from "~/lib/styles";

export const Container = styled.div`
  position: absolute;
  inset-block-start: 0;
  inset-inline-start: 0;
  z-index: ${ZIndexLayer.ArticleAcknowledgementGateOverlay};

  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100vw;
  block-size: 100vh;

  background-color: #ffffff;
`;

export const ContentContainer = styled.div`
  max-inline-size: 760px;
  margin-block: 0;
  margin-inline: 16px;
  padding: 24px;

  font-weight: normal;
  font-size: 16px;
  font-family: ${fontRoboto};
  line-height: 21px;

  border: 1px solid #e5e5e5;
  border-radius: 4px;

  ${props => props.theme.breakpoints.up("tablet")} {
    padding: 40px;
  }
`;

export const ContentBody = styled.div``;

export const ContentBodyText = styled.p`
  margin-block-start: 21px;
`;

export const ContentFooter = styled.div`
  margin-block-start: 21px;
  padding-block-start: 32px;
  border-block-start: 1px solid #d8d8d8;
`;

export const StyledLogoText = styled(LogoText)`
  display: inline-block;

  margin-inline-start: 7px;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 290px;
    block-size: 35px;
  }
`;

export const StyledLogoFlag = styled(LogoFlag)`
  display: inline-block;

  ${props => props.theme.breakpoints.up("tablet")} {
    inline-size: 45px;
    block-size: 35px;
  }
`;

export const StyledLogo = styled(BaseLink)`
  display: flex;
  align-items: center;
`;

export const StyledAnchor = styled.a`
  color: #4585ff;

  cursor: pointer;
`;

export const StyledBaseLink = styled(BaseLink)`
  color: #4585ff;
`;
